import * as React from "react";
import { cn } from "../../utils/cn";

const Input = React.forwardRef(({ className, type, onFocus, value, ...props }, ref) => {
  const handleFocus = (e) => {
    if (type === 'number' && e.target.value === '0') {
      e.target.select();
    }
    onFocus?.(e);
  };

  const displayValue = type === 'number' && value !== undefined && value !== null && value !== ''
    ? String(Number(value))
    : value;

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      onFocus={handleFocus}
      value={displayValue}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
